import { render, staticRenderFns } from "./BaseCheckChip.vue?vue&type=template&id=00bb1e47&scoped=true&"
import script from "./BaseCheckChip.vue?vue&type=script&lang=ts&"
export * from "./BaseCheckChip.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCheckChip.vue?vue&type=style&index=0&id=00bb1e47&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bb1e47",
  null
  
)

export default component.exports